import useDevice from './useDevice';

export default useDevice;
